import React, { useMemo, useState } from 'react'

import { OnboardingCheckbox } from 'onboarding/components/ui/theme'

import { groupSubcategoriesByBusinessUnits } from '../helpers/groupSubcategoriesByBusinessUnits'
import { orderGroupedSubcategories } from '../helpers/orderGroupedSubcategories'

import { TSubcategory } from './models'

import styles from './Subcategories.module.scss'

interface IProps {
  subcategories: TSubcategory[]
  businessUnits: string[]
  checkIsChosen: (guid: string) => boolean
  onChoose: (item: TSubcategory) => void
  isDisabled?: boolean
}

export const Subcategories = ({
  subcategories,
  businessUnits,
  checkIsChosen,
  onChoose,
  isDisabled,
}: IProps) => {
  const [groupedSubcategories] = useState(() => {
    const grouped = groupSubcategoriesByBusinessUnits(subcategories, businessUnits)

    return orderGroupedSubcategories(grouped, businessUnits)
  })
  const isGrouped = useMemo(
    () => Boolean(Object.keys(groupedSubcategories).length),
    [groupedSubcategories]
  )
  const nonGroupedSubcategories = useMemo(() => {
    let result = subcategories
    if (isGrouped) {
      const items = Object.values(groupedSubcategories)
        .flat()
        .map((i) => i.guid)

      result = subcategories.filter((subcategory) => !items.includes(subcategory.guid))
    }

    return result
  }, [subcategories, groupedSubcategories, isGrouped])

  const renderSubcategories = (subcategories: TSubcategory[]) => {
    return (
      <div className={styles.subcategories}>
        {subcategories.map((subcategory) => (
          <OnboardingCheckbox
            key={subcategory.guid}
            checked={checkIsChosen(subcategory.guid)}
            label={<span className={styles.subcategoryTitle}>{subcategory.title}</span>}
            onChange={() => onChoose(subcategory)}
            disabled={isDisabled}
            inline
          />
        ))}
      </div>
    )
  }

  return isGrouped ? (
    <div className={styles.container}>
      <div className={styles.groups}>
        {Object.keys(groupedSubcategories).map((column) => {
          const subcategories = groupedSubcategories[column]
          return (
            <div key={column} className={styles.column}>
              {subcategories.map((subcategory) => {
                return (
                  <OnboardingCheckbox
                    key={subcategory.guid}
                    checked={checkIsChosen(subcategory.guid)}
                    label={<span className={styles.subcategoryTitle}>{subcategory.title}</span>}
                    onChange={() => onChoose(subcategory)}
                    className={styles.item}
                    disabled={isDisabled}
                    inline
                  />
                )
              })}
            </div>
          )
        })}
      </div>
      {Boolean(nonGroupedSubcategories.length) && renderSubcategories(nonGroupedSubcategories)}
    </div>
  ) : (
    renderSubcategories(nonGroupedSubcategories)
  )
}
